export class DigitalSignatureRequest {
  communicationSignature: string;
  profilingSignature: string;
  dataSharingSignature: string;
}
